<template>
  <FormMainContainer
    :title="title"
    :breadcrumb="getBreadcrumb"
    :previous-step-route="previousStepRoute"
  >
    <KbQuestions :lang="lang" :questions="questions" />
  </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import FormMainContainer from '~concierge/components/FormMainContainer.vue'
import HeaderSection from '~concierge/components/HeaderSection.vue'
import FooterSection from '~concierge/components/FooterSection.vue'
import KbQuestions from '~conciergeUiCommons/components/KnowledgeDatabase/KbQuestions.vue'
import { BreadcrumbResource, KbQAData, KbLocalization } from '~types/concierge'
import { useSubmissionFormStore } from '~conciergeUiCommons/store/submissionFormStore'

export default defineComponent({
  components: { HeaderSection, FooterSection, KbQuestions, FormMainContainer },
  props: {
    questions: {
      type: Array as PropType<KbQAData[]>,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    previousStepRoute(): string {
      if (this.questions.length) {
        const question = this.questions.find(e => typeof e !== 'undefined')

        return question?.endpoints.kb[this.lang as keyof KbLocalization] ?? ''
      }

      return ''
    },
    getBreadcrumb(): { [key: number]: BreadcrumbResource } {
      if (this.questions.length) {
        const question = this.questions.find(e => typeof e !== 'undefined')

        return question?.breadcrumb[this.lang as keyof KbLocalization] ?? []
      }

      return []
    },
    lang(): string {
      return useSubmissionFormStore().formLanguage
    }
  }
})
</script>
